module.exports = __webpack_public_path__ + "img/S-WEB-Goal-12.c96b79eb.png";